
/**
 * アイコン - インフォメーション
 */
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IconInformation',
  props: {
    stroke: {
      type: String,
      default: '#fff',
    },
  },
})
